import React, { useState, useEffect } from 'react';

import styles from './WrittenText.module.css';

const WrittenText = () => {
  const paragraph = `Hi! I'm interested in learning more about your phone product suite, can I set up a demo with a member of your team?`;
  const [text, setText] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      if (text.length < paragraph.length) {
        const newText = paragraph.slice(0, text.length + 1);
        setText(newText);
      } else {
        clearInterval(interval);
      }
    }, 25);
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [text]);

  return (
    <div className="w-full py-8 px-6 flex flex-grow items-center">
      <p className="text-lg text-black">
        <span className={styles.textWrapper}>{text}</span>
      </p>
    </div>
  );
};

export default WrittenText;
